import { render, staticRenderFns } from "./serviceType.vue?vue&type=template&id=1736d588&scoped=true&"
import script from "./serviceType.vue?vue&type=script&lang=js&"
export * from "./serviceType.vue?vue&type=script&lang=js&"
import style0 from "./serviceType.vue?vue&type=style&index=0&id=1736d588&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1736d588",
  null
  
)

export default component.exports